import React from 'react';
import PropTypes from 'prop-types';

import useScreenMode from '../../../hooks/useScreenMode';
import { getImagesStaticUrl } from '../../../helpers';
import { MOBILE } from '../../constants';
import styles from './banner.module.scss';

const Banner = ({ title, subtitle }) => {
  const screenMode = useScreenMode();
  return (
    <div
      className={styles.banner}
      style={
        screenMode === MOBILE
          ? {}
          : { backgroundImage: `url(${getImagesStaticUrl('subscribe-hero-desktop.png')})` }
      }
      data-testid="banner-container"
    >
      <h1 className={styles.banner__title}>{title}</h1>
      <p className={styles.banner__subtitle} data-testid="banner-subtitle">{subtitle}</p>
      {screenMode !== MOBILE && (
        <img src={getImagesStaticUrl('subscribe-white-wave.svg')} alt="white wave" />
      )}
    </div>
  );
};

Banner.defaultProps = {
  title: '',
  subtitle: '',
};

Banner.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default Banner;
